import { render, staticRenderFns } from "./SchoolEducationLayout.vue?vue&type=template&id=bd9e0a42&scoped=true"
import script from "./SchoolEducationLayout.vue?vue&type=script&lang=js"
export * from "./SchoolEducationLayout.vue?vue&type=script&lang=js"
import style0 from "./SchoolEducationLayout.vue?vue&type=style&index=0&id=bd9e0a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9e0a42",
  null
  
)

export default component.exports